import type { SearchAccess } from "./searchTypes";

/**
 * Mirrors sidebar/header navigation gates in Sidebar.tsx and Header.tsx.
 * Route registration is not enough — SUBADMIN still has admin routes registered.
 */
export function getSearchAccess(
  user: Record<string, any> | null,
): SearchAccess {
  const userRole = String(user?.userRole || "");
  const isDisabled = user?.isDisabled === 1 || user?.isDisabled === "1";
  const isFullAdmin = userRole === "ADMIN" && !isDisabled;
  const isAdminRole = userRole === "ADMIN";
  const isEnabledSubadmin = userRole === "SUBADMIN" && !isDisabled;
  const hasAccessFlag = user?.access === true;
  const isCommittee = user?.committeeMember === true;
  const hasCoupleProfile = user?.coupleId !== null && user?.coupleId !== undefined;

  const canManageRetreats =
    isFullAdmin ||
    (isAdminRole && isDisabled && hasAccessFlag) ||
    (isEnabledSubadmin && (isCommittee || hasAccessFlag)) ||
    (userRole === "SUBADMIN" && isDisabled && hasAccessFlag) ||
    (userRole === "COUPLE" && (isCommittee || (hasAccessFlag && !isDisabled)));

  const userId = user?.id ?? null;

  return {
    isAuthenticated: Boolean(user),
    userId,
    userRole,
    isFullAdmin,
    isAdminRole,
    hasCoupleProfile,
    canViewCouples: isFullAdmin || isEnabledSubadmin,
    canViewMasterData: isFullAdmin,
    canViewAdminDashboard: isFullAdmin,
    canViewTickets: isFullAdmin,
    canViewClosures: isFullAdmin,
    canManageRetreats,
    canViewProjected: isAdminRole && canManageRetreats,
    canViewRoster: canManageRetreats,
    canViewUpcoming: Boolean(user),
    actor: {
      actorName: user?.userName || "Admin",
      actorRole: userRole || "ADMIN",
      actorUserId: userId,
      isAdmin: isAdminRole,
      isSuperAdmin: isAdminRole,
      accessId: userId,
    },
  };
}
